<template>
  <a-card :bordered="false">
    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
    >
    </s-table>
  </a-card>
</template>
<script>

import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'

import { getUserDetailList } from '@/api/user'

export default {
  name: "UserRecord",
  components: {
    AInput,
    STable
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      queryParam: {},
      // 表头
      columns: [
        
        {
          title: '兑换单编号',
          dataIndex: 'order_no'
        },
        {
          title: '兑换门店',
          dataIndex: 'branch_name'
        },
        {
          title: '兑换时间',
          dataIndex: 'created'
        },
        {
          title: '消耗娃娃数',
          dataIndex: 'quantity_used',
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getUserDetailList(Object.assign(params, {id:this.$route.params.id})).then(res => res)
      },
    }
  },
   created () {
  },
  methods: {

  },
}
</script>
<style scoped>
</style>

